export const textToImage = (text) => {
  if (!text) return '';
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.font = '80px Alex Brush';
  const textWidth = ctx.measureText(text).width;
  ctx.fillText(text, canvas.width / 2 - textWidth / 2, 100);
  return canvas.toDataURL();
};
